__turbopack_context__.v({
  "caption": "Q0CNla_caption",
  "carousel": "Q0CNla_carousel",
  "image": "Q0CNla_image",
  "root": "Q0CNla_root",
  "slide": "Q0CNla_slide",
});
